import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { usePunditUserContext } from "@circle-react/contexts";
import type { PlanIntervals } from "@circle-react/helpers/plansHelpers";
import {
  hasCurrentPlanAnAlternativePlan,
  planIntervals,
} from "@circle-react/helpers/plansHelpers";
import { BillingCycleLink } from "./BillingCycleLink";
import { usePlans } from "./PlansContext";

export const BillingCycle = () => {
  const { billingCycle, currentPlan } = usePlans();
  const { currentCommunity } = usePunditUserContext();
  const isSelected = (planInterval: PlanIntervals) => {
    if (!billingCycle && currentPlan) {
      return !currentCommunity?.is_on_trial;
    }

    return billingCycle === planInterval;
  };

  return hasCurrentPlanAnAlternativePlan(currentPlan) ? (
    <div>
      <div
        className={classNames(
          "bg-secondary mt-0 flex w-full flex-row space-x-1 rounded-lg p-1 text-sm",
        )}
      >
        <BillingCycleLink
          interval={planIntervals.year}
          isSelected={isSelected}
          label={t("pricing_plans.billing_cycle.annually")}
        />
        <BillingCycleLink
          interval={planIntervals.month}
          isSelected={isSelected}
          label={t("pricing_plans.billing_cycle.monthly")}
        />
      </div>
    </div>
  ) : (
    <div />
  );
};
